import Vue from 'vue';
import http from 'axios';

http.interceptors.request.use(config => {
  const token = localStorage.getItem('roupoo-token')

  config.headers.Authorization = token
  return config
})


http.interceptors.response.use(response => {
    return response
}, err => {
    if (401 === err.response.status) {
        window.location.href = '/login'
    } else {
        return Promise.reject(error);
    }
})

Vue.prototype.$http = http

export default Vue;


// WEBPACK FOOTER //
// ./src/lib/Vue.js